import { DATABASE_CACHE_KEY, DATABASE_KEY, DATABASE_KEY_LOCALE } from 'src/database/constants.ts';

export const handleRegularLoadFail = async (
    databaseCache: LocalForage,
    offlineDatabase: LocalForage,
) => {
    await offlineDatabase.removeItem(DATABASE_KEY);
    await offlineDatabase.removeItem(DATABASE_KEY_LOCALE);
    await databaseCache.removeItem(DATABASE_CACHE_KEY);
};
